import React, { useState, useEffect } from 'react'
// import Modal from '../Modal/modal'
import Map from '../Map'
import './popup.css'

// import { useQuery } from '@apollo/react-hooks'
import { FOCUS_PROPS2 } from 'functions'
import RegionSelect, { SubscriptionPastDue } from 'components/RegionSelect'
const subscriptionPastDue = false
export default function Popup() {

	// const [ open, setOpen ] = useState()
	const region = 'canada'

	const [ provinceCode, setProvinceCode ] = useState(process.env.NODE_ENV === 'development' ? 'PE' : '')

	const [ center, setCenter ] = useState({
		lat: 54.9399,
		lng: -104.4509
	})
	const [ zoom, setZoom ] = useState(4)
	
	useEffect(() => {
		if (navigator && navigator.geolocation) {
			// console.log('navigator enabled')
			navigator.geolocation.getCurrentPosition((pos) => {
				const { latitude, longitude } = pos.coords
				setCenter({
					lat: parseFloat(latitude),
					lng: parseFloat(longitude)
				})
			})
		}
	}, [])

	useEffect(() => {
		if (provinceCode) {
			setZoom(FOCUS_PROPS2[provinceCode].zoom)
			setCenter({ lat: FOCUS_PROPS2[provinceCode].latitude, lng: FOCUS_PROPS2[provinceCode].longitude })
		}
	}, [provinceCode])
	
	if (subscriptionPastDue) {
	return <SubscriptionPastDue />
	}

	if (!provinceCode) return <RegionSelect onChange={ (region) => setProvinceCode(region) } />
	
	return (
		<>
			<Map region={region} center={ center } zoom={ zoom } provinceCode={ provinceCode } clearProvinceCode={() => setProvinceCode()}></Map>
			{/* <div id="map" className="map__container"/> */}
		</>
	)
}


// onOpenModal = () => {
// 	this.setState({ open: true })
// };

// onCloseModal = () => {
// 	this.setState({ open: false })
// };


// selectRegion = (data) => {

// 	this.setState({ region: data, open: false })

// }

// class Popup extends Component {

// 	constructor(props) {
// 		super(props);
// 		this.state = {
// 			open: false,
// 			region: 'canada',
// 			center: {}
// 		}
// 	}

// 	onOpenModal = () => {
// 		this.setState({ open: true })
// 	};

// 	onCloseModal = () => {
// 		this.setState({ open: false })
// 	};


// 	selectRegion = (data) => {

// 		this.setState({ region: data, open: false })

// 	}

// 	componentDidMount() {
// 		console.log('mounted')
// 		if (navigator && navigator.geolocation) {
// 			console.log('navigator enabled')
// 			navigator.geolocation.getCurrentPosition((pos) => {
// 				console.log('pos', pos)
// 				const { latitude, longitude } = pos.coords
// 				this.setState({
// 					center: {
// 						latitude,
// 						longitude
// 					}
// 				})
// 			})
// 		}
// 	}

// 	render() {
// 		return (
// 			<Query query={ GET_MAP_PINS }>
// 				{({ loading, error, data }) => {
// 					if (loading) return 'Loading...';
// 					if (error) return `Error! ${error.message}`;
			
// 					return (
// 						<Map region={this.state.region} mapPins={data.mapPins} center={ this.state.center }></Map>
// 					);
// 				}}
// 			</Query>
// 		)
// 	}
// }

// export default (Popup)
